import Vue from 'vue'
import DPov from "dpov-vue-library"; // "dpov-vue-components" is aliased in quasar.conf.js

window.log = new DPov.Logger({level:process.env.LOG_LEVEL, usePrefix: false, colorized: true})
Vue.prototype.$log = window.log;

Vue.use(DPov)